import '../../../../styles/Stand/Documents.css';

import { DeleteOutlined }            from '@ant-design/icons';
import { FileZipOutlined }           from '@ant-design/icons';
import { Modal }                     from 'antd';
import { AppForm }                   from 'components/App/AppForm';
import dayjs                         from 'dayjs';
import React                         from 'react';
import { observer }                  from 'mobx-react';
import { FileTextOutlined }          from '@ant-design/icons';
import { DownloadOutlined }          from '@ant-design/icons';
import { Skeleton }                  from 'antd';
import { CheckCircleOutlined }       from '@ant-design/icons';
import { List }                      from 'antd';
import { CheckSquareOutlined }       from '@ant-design/icons';
import { notification }              from 'antd';
import { QuestionCircleOutlined }    from '@ant-design/icons';
import { Button }                    from 'antd';
import { Space }                     from 'antd';
import CardBox                       from 'components/App/CardBox';
import { MODE_ICON }                 from 'components/App/DropDownMenu';
import FormattedMessageWrapper       from 'components/App/FormattedMessageWrapper';
import StandDocumentsZipModel        from 'models/StandDocumentsZipModel';
import { downloadFileFromBlob }      from 'utils/downloadFile';
import { downloadFileFromUrl }       from 'utils/downloadFile';
import DropDownMenu                  from 'components/App/DropDownMenu';
import { formatMessageIntl }         from 'utils/messageIntl';
import { messageErrorIntl }          from 'utils/messageIntl';
import StandDocumentMediaStatus      from '../../../../components/StandDocumentMedia/StandDocumentMediaStatus';
import standDocumentMediaStatuses    from 'constants/StandDocumentMediaStatuses';
import handleApiError                from 'utils/handleApiError';
import rights                        from 'utils/rights';
import StandDocumentMessageModel     from 'models/StandDocumentMessageModel';
import StandDocumentMessageForm      from 'forms/StandDocumentMessageForm';
import StandDocumentMediaModel       from 'models/StandDocumentMediaModel';
import StandDocumentMediaStatusModel from 'models/StandDocumentMediaStatusModel';
import ShowModel                     from 'models/ShowModel';
import StandModel                    from 'models/StandModel';
import { ApiCollection }             from 'collections/ApiCollection';

const styleIcon = {
  fontSize: '22px',
  marginRight: 6,
};

interface StandDocumentMediaListBoxProps {
  fetchParentData: () => void;
  setDataLoading: (loading: boolean) => void;
  show: ShowModel;
  stand: StandModel;
  standDocumentMediaCollection: ApiCollection<StandDocumentMediaModel>;
  standDocumentMediaStatusCollection: ApiCollection<StandDocumentMediaStatusModel>;
}

@observer
class StandDocumentMediaListBox extends React.Component<StandDocumentMediaListBoxProps> {

  public static defaultProps = {
    setDataLoading: () => {},
  };

  public state = {
    standDocumentMessage: new StandDocumentMessageModel(),
  };

  public render() {
    const {
      fetchParentData,
      standDocumentMediaCollection,
      standDocumentMediaStatusCollection,
    } = this.props;

    return (
      <CardBox
        // className="accented-shadow"
        content={
          <List
            dataSource={[ ...standDocumentMediaCollection.models, ] as StandDocumentMediaModel[]}
            itemLayout="horizontal"
            loading={standDocumentMediaCollection.isLoading}
            locale={{
              emptyText: <FormattedMessageWrapper id="Aucun document" />,
            }}
            renderItem={(standDocumentMedia: StandDocumentMediaModel) => {
              if (!standDocumentMedia.enabled) {
                return null;
              }

              return (
                <List.Item
                  actions={[
                    <DropDownMenu
                      items={[
                        {
                          icon: <DownloadOutlined />,
                          key: 'DOWNLOAD',
                          label: <FormattedMessageWrapper id="Télécharger" />,
                          onClick: () => {
                            this.openDocument(standDocumentMedia);
                          },
                        },
                        {
                          disabled:
                            standDocumentMedia.standDocumentMediaStatusReference ===
                            standDocumentMediaStatuses.TO_CHECK.reference,
                          hidden: !rights.for.standDocumentMedia.newStatus,
                          icon: <QuestionCircleOutlined />,
                          key: 'TO_CHECK',
                          label: standDocumentMediaStatuses.TO_CHECK.label,
                          onClick: () => {
                            this.setStandDocumentMediaStatus(
                              standDocumentMedia,
                              standDocumentMediaStatuses.TO_CHECK.reference,
                            );
                          },
                        },
                        {
                          disabled:
                            standDocumentMedia.standDocumentMediaStatusReference ===
                            standDocumentMediaStatuses.PENDING_INFORMATIONS.reference,
                          hidden: !rights.for.standDocumentMedia.newStatus,
                          icon: <QuestionCircleOutlined />,
                          key: 'PENDING_INFORMATIONS',
                          label: standDocumentMediaStatuses.PENDING_INFORMATIONS.label,
                          onClick: () => {
                            this.setStandDocumentMediaStatus(
                              standDocumentMedia,
                              standDocumentMediaStatuses.PENDING_INFORMATIONS.reference,
                            );
                          },
                        },
                        {
                          disabled:
                            standDocumentMedia.standDocumentMediaStatusReference ===
                            standDocumentMediaStatuses.CHECKED.reference,
                          hidden: !rights.for.standDocumentMedia.newStatus,
                          icon: <CheckCircleOutlined />,
                          key: 'CHECKED',
                          label: standDocumentMediaStatuses.CHECKED.label,
                          onClick: () => {
                            this.setStandDocumentMediaStatus(
                              standDocumentMedia,
                              standDocumentMediaStatuses.CHECKED.reference,
                            );
                          },
                        },
                        {
                          disabled:
                            standDocumentMedia.standDocumentMediaStatusReference ===
                            standDocumentMediaStatuses.CHECKED_WITH_OPTION.reference,
                          hidden: !rights.for.standDocumentMedia.newStatus,
                          icon: <CheckSquareOutlined />,
                          key: 'CHECKED_WITH_OPTION',
                          label: standDocumentMediaStatuses.CHECKED_WITH_OPTION.label,
                          onClick: () => {
                            this.setStandDocumentMediaStatus(
                              standDocumentMedia,
                              standDocumentMediaStatuses.CHECKED_WITH_OPTION.reference,
                            );
                          },
                        },
                        {
                          disabled:
                            standDocumentMedia.standDocumentMediaStatusReference ===
                            standDocumentMediaStatuses.REFUSED.reference,
                          hidden: !rights.for.standDocumentMedia.newStatus,
                          icon: <CheckSquareOutlined />,
                          key: 'REFUSED',
                          label: standDocumentMediaStatuses.REFUSED.label,
                          onClick: () => {
                            this.setStandDocumentMediaStatus(
                              standDocumentMedia,
                              standDocumentMediaStatuses.REFUSED.reference,
                            );
                          },
                        },
                        {
                          danger: true,
                          hidden: !rights.for.standDocumentMedia.delete,
                          icon: <DeleteOutlined />,
                          key: 'DELETE',
                          label: <FormattedMessageWrapper id="Supprimer" />,
                          onClick: () => {
                            Modal.confirm({
                              cancelText: formatMessageIntl('Non'),
                              icon: <QuestionCircleOutlined style={{ color: '#e74c3c' }} />,
                              okText: formatMessageIntl('Oui'),
                              onOk: async () => {
                                try {
                                  await standDocumentMedia.patch({
                                    enabled: false,
                                  });
                                  notification.success({
                                    message: formatMessageIntl("Suppression réussie !"),
                                  });
                                  fetchParentData();
                                } catch (error) {
                                  handleApiError(error);
                                }
                              },
                              title: formatMessageIntl("Êtes-vous sûr de vouloir supprimer ce document ?"),
                            });
                          },
                        },
                      ]}
                      key="drop_down_menu"
                      mode={MODE_ICON}
                    />,
                  ]}
                >
                  <Skeleton active avatar loading={standDocumentMedia.isLoading} title={false}>
                    <List.Item.Meta
                      avatar={
                        <div style={{ width: 160 }}>
                          <StandDocumentMediaStatus
                            standDocumentMedia={standDocumentMedia}
                            standDocumentMediaStatusCollection={
                              standDocumentMediaStatusCollection
                            }
                          />
                        </div>
                      }
                      description={
                        <div>
                          {`Le ${standDocumentMedia.messageUpdatedAtDate.format(
                            'DD/MM/YYYY',
                          )} à ${standDocumentMedia.messageUpdatedAtDate.format('HH[h]mm')}`}
                          <br />
                          {`Par ${standDocumentMedia.messageCreatedByLastName} ${
                            standDocumentMedia.messageCreatedByFirstName
                          }`}
                        </div>
                      }
                      title={<b>{standDocumentMedia.mediaFileName}</b>}
                    />
                  </Skeleton>
                </List.Item>
              );
            }}
          />
        }
        extra={this.renderDropDownMenu()}
        title={
          <div style={{ alignItems: 'center', display: 'flex', flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', flex: 1 }}>
              <FileTextOutlined style={{ ...styleIcon }} />
              <FormattedMessageWrapper id="Documents" />
            </div>
          </div>
        }
      />
    );
  }

  public renderDropDownMenu = () => {
    const { show } = this.props;

    const items = [];

    if (rights.for.standDocumentMedia.zip) {
      items.push({
        icon: <FileZipOutlined />,
        key: 'DOWNLOAD_ZIP',
        label: <FormattedMessageWrapper id="Télécharger tous les documents" />,
        onClick: () => this.downloadStandDocuments(),
      });
    }

    return (
      <Space direction="horizontal">
        <Button
          disabled={!show.enabled || !rights.for.standDocumentMessage.add}
          htmlType="button"
          onClick={() => {
            this.openStandDocumentMessageFormModal(new StandDocumentMessageModel());
          }}
          type="primary"
        >
          <FormattedMessageWrapper id="Déposer mes documents" />
        </Button>

        {!!items.length && <DropDownMenu items={items} mode={MODE_ICON} />}
      </Space>
    );
  };

  private downloadStandDocuments = () => {
    const { setDataLoading, show, stand } = this.props;

    setDataLoading(true);

    const standDocumentsZipModel = new StandDocumentsZipModel();

    const standsIds = [stand.id];

    standDocumentsZipModel
      .fetch({
        params: {
          ids: standsIds,
        },
      })
      .then(
        (response: any) => {
          const time = dayjs().format('YYYY-MM-DD_HHmm');
          let fileName = [show.showName, stand.name, 'Documents', time].join(' - ');
          fileName += '.zip';
          const blob = new Blob([response.data], { type: 'application/zip' });
          downloadFileFromBlob(blob, fileName);
        },
        error => {
          if (error.connectorError.response.status === 400) {
            messageErrorIntl("Aucun document.");
          } else {
            handleApiError(error);
          }
        },
      )
      .finally(() => {
        setDataLoading(false);
      });
  };

  private openDocument = (media: any) => {
    const filename = media.get('mediaFileName', 'download');
    downloadFileFromUrl(media.get('objectUrl'), filename);
  };

  private openStandDocumentMessageFormModal = (standDocumentMessage: StandDocumentMessageModel) => {
    const { fetchParentData, stand } = this.props;

    AppForm.open(StandDocumentMessageForm, {
      onSuccess: () => {
        fetchParentData();
      },
      stand: stand,
      standDocumentMessage: standDocumentMessage,
    }, {
      okText: <FormattedMessageWrapper id="Envoyer" />,
      title: <FormattedMessageWrapper id="Envoyer un message" />,
    });
  };

  private setStandDocumentMediaStatus = async (media: any, statusReference: string) => {
    const { fetchParentData, standDocumentMediaStatusCollection } = this.props;

    const standDocumentMediaStatus = standDocumentMediaStatusCollection.findBy(
      'reference',
      statusReference,
    ) as StandDocumentMediaStatusModel;

    if (!standDocumentMediaStatus) {
      notification.error({
        title: formatMessageIntl("Erreur statut"),
      });

      return;
    }

    try {
      await media.patch({
        standDocumentMediaStatus: standDocumentMediaStatus.iri,
      });

      notification.success({
        title: formatMessageIntl("Nouveau statut enregistré !"),
      });

      fetchParentData();
    } catch (error) {
      handleApiError(error);
    }
  };
}

export default StandDocumentMediaListBox;
